'use client';

const ButtonCTA: React.FC = () => {
  return (
    <button
      type='button'
      onClick={() => window.open('https://app.meapoia.com', '_self')}
      className='rounded-lg bg-brand-medium-2 px-6 py-3 font-semibold text-white transition-all duration-200 hover:bg-brand-medium-1'
    >
      Crie sua campanha agora
    </button>
  );
};

export default ButtonCTA;
